import { render, staticRenderFns } from "./addExpenseType.vue?vue&type=template&id=469267e0&scoped=true&"
import script from "./addExpenseType.vue?vue&type=script&lang=js&"
export * from "./addExpenseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469267e0",
  null
  
)

export default component.exports